import { render, staticRenderFns } from "./industrialSystem.vue?vue&type=template&id=b20ca9e2&scoped=true&"
import script from "./industrialSystem.vue?vue&type=script&lang=js&"
export * from "./industrialSystem.vue?vue&type=script&lang=js&"
import style0 from "./industrialSystem.vue?vue&type=style&index=0&id=b20ca9e2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20ca9e2",
  null
  
)

export default component.exports